// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Definición de la colección LoginColl baked at build time.
// NO EDITAR: se regenera en cada build.

export const COLL_DEF = {
  "name": "LoginColl",
  "tableName": "LoginColl",
  "tablePrefix": "gen",
  "idFieldName": "ROWID",
  "fields": [
    {
      "name": "MAP_LOGO",
      "type": "IMG",
      "title": "Logo"
    },
    {
      "name": "USER",
      "type": "T",
      "title": "Usuario"
    },
    {
      "name": "PWD",
      "type": "X",
      "title": "Contraseña"
    },
    {
      "name": "ROWID",
      "type": "T",
      "size": 32
    }
  ],
  "special": true
} as const;
